import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

import { ThemeLogoIcon } from '~/views/theme-overview/components/theme-logo-icon/ThemeLogoIcon';

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TitleMedium = styled.div`
  ${typographyV2.titleMd};
`;

export const BodySmall = styled.div`
  ${typographyV2.bodySm};
`;

export const StepperWrapper = styled.div`
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 18px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const ThemeRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid var(--border-soft);
  padding: 12px 8px 12px 12px;

  &:not(:last-child) {
    border-bottom: none;
  }

  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const ThemeNameWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  ${typographyV2.bodySm};

  ${ThemeLogoIcon.Styled.StyledLogoImg} {
    width: 32px;
    height: 32px;
  }
`;

export const ThemeName = styled.span`
  ${typographyV2.bodySm};
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--kg-theme);
  height: 32px;
  width: 32px;
  border-radius: 40px;
  color: var(--text-default);
  ${typographyV2.titleSm}
`;
